import { render, staticRenderFns } from "./DocumentPassport.vue?vue&type=template&id=213c3571&scoped=true"
var script = {}
import style0 from "./DocumentPassport.vue?vue&type=style&index=0&id=213c3571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c3571",
  null
  
)

export default component.exports